import { MeetingRequestViewState } from 'owa-meeting-message/lib/store/schema/MeetingRequestViewState';
import NonEmptyArrayOfAllItemsType from 'owa-service/lib/contract/NonEmptyArrayOfAllItemsType';
import { action } from 'satcheljs';

export default action(
    'processGetItemResponse',
    (
        itemId: string,
        conflictMeetings: NonEmptyArrayOfAllItemsType,
        adjacentMeetings: NonEmptyArrayOfAllItemsType,
        meetingRequestViewState: MeetingRequestViewState
    ) => ({
        itemId,
        conflictMeetings,
        adjacentMeetings,
        meetingRequestViewState,
    })
);
